<template>
	<div class="ui segment">
		<div class="ui top attached label">Online resources:</div>
		<div v-if="onlineResource.urlDownload != null">URL download : <a :href="getI18n(onlineResource.urlDownload,'en')">{{getI18n(onlineResource.urlDownload,"en")}}</a></div>
		<div v-if="onlineResource.urlInfo != null">URL info : <a :href="getI18n(onlineResource.urlInfo,'en')">{{getI18n(onlineResource.urlInfo,"en")}}</a></div>
		<div v-if="onlineResource.doi">DOI : <a :href="'http://dx.doi.org/' + onlineResource.doi">{{onlineResource.doi}}</a></div>
		<div v-if="onlineResource.webservices != null" class="ui segment">
			<div class="ui top left attached label">Webservices:</div>
			<div v-for="(webservice, index) in onlineResource.webservices" :key="index">
				<div class="ui segment">
					<div>Description : {{getI18n(webservice.description,"en")}}</div>
					<div>Url : <a :href="getI18n (webservice.url,'en')">{{getI18n (webservice.url,"en")}}</a></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: ["onlineResource"],
  methods: {
    /**
     * Getter to get the value according the the internationalisation
     */
    getI18n(el, lang) {
      let tmp = el.find(element => element.lang === lang);
      return tmp.text;
    }
  }
};
</script>

<style>
</style>
